import { motion } from "framer-motion";
import { SITE } from "@/config/site";
import { EASE } from "@/components/motion/Reveal";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
    <path fill="currentColor" d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35M12.05 21.8h-.01a9.9 9.9 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.89 9.9-9.89 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 7c0 5.45-4.44 9.88-9.89 9.88m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41" />
  </svg>
);

export const WhatsAppButton = () => {
  const number = SITE.contact.whatsapp;
  if (!number) return null;
  const text = encodeURIComponent("Hello VION Tech, I'd like to make an enquiry.");
  return (
    <motion.a
      href={`https://wa.me/${number}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with VION Tech on WhatsApp"
      data-testid="floating-whatsapp-btn"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: EASE, delay: 1.6 }}
      className="group fixed bottom-5 right-5 z-30 flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 bg-plum text-white shadow-[0_12px_30px_-10px_rgba(0,0,0,0.6)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-plum-2 sm:bottom-7 sm:right-7"
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    >
      <span aria-hidden="true" className="absolute inset-0 rounded-full border border-gold/40 opacity-0 transition-[opacity,transform] duration-500 group-hover:scale-125 group-hover:opacity-100" />
      <WhatsAppIcon />
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-ink px-4 py-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-gold-light opacity-0 transition-opacity duration-300 group-hover:opacity-100 sm:block">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
};
